import { useState, useEffect } from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useTimer = function useTimer(count, onFinish) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var _useState3 = useState(count),
      _useState4 = _slicedToArray(_useState3, 2),
      counter = _useState4[0],
      setCounter = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      seconds = _useState6[0],
      setSeconds = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      minutes = _useState8[0],
      setMinutes = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      hours = _useState10[0],
      setHours = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      days = _useState12[0],
      setDays = _useState12[1];

  useEffect(function () {
    var intervalId;

    if (isActive) {
      intervalId = setInterval(function () {
        if (counter >= 1) {
          setCounter(function (counter) {
            return counter - 1;
          });
        } else {
          setIsActive(false);

          if (onFinish) {
            onFinish();
          }
        }

        var secondCounter = counter % 60;
        var minuteCounter = Math.floor(counter % 3600 / 60);
        var hourCounter = Math.floor(counter % (3600 * 24) / 3600);
        var daysCounter = Math.floor(counter / (3600 * 24));
        var computedSecond = String(secondCounter).length === 1 ? "0".concat(secondCounter) : secondCounter;
        var computedMinute = String(minuteCounter).length === 1 ? "0".concat(minuteCounter) : minuteCounter;
        var computedHour = String(hourCounter).length === 1 ? "0".concat(hourCounter) : hourCounter;
        var computedDay = String(daysCounter).length === 1 ? "0".concat(daysCounter) : daysCounter;
        setSeconds(computedSecond);
        setMinutes(computedMinute);
        setHours(computedHour);
        setDays(computedDay);
      }, 1000);
    }

    return function () {
      return clearInterval(intervalId);
    };
  }, [isActive, counter, onFinish]);

  function pause() {
    setIsActive(false);
  }

  function resume() {
    setIsActive(true);
  }

  function reset() {
    setCounter(count);
    setSeconds("00");
    setMinutes("00");
    setHours("00");
    setDays("00");
    setIsActive(true);
  }

  return {
    isActive: isActive,
    counter: counter,
    seconds: seconds,
    minutes: minutes,
    hours: hours,
    days: days,
    pause: pause,
    resume: resume,
    reset: reset
  };
};

export { useTimer };
//# sourceMappingURL=index.es.js.map
